import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  ServiceRefreshment: {
    currency: '',
    price_per_person: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
